<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import useFilter from '../hooks/use-filter'
  import Briefcase from './Briefcase.svelte'
  import OrderBy from './OrderBy.svelte'

  const { footer } = useFilter()
  const { briefcase, orderBy } = footer

  const dispatch = createEventDispatcher()
  const onChange = () => dispatch('orderchange')
</script>

<div
  class="flex flex-col gap-3 rounded-sm border border-gray-200 bg-[#f2f2f2] p-2 sm:flex-row sm:justify-between sm:py-0.5"
>
  <OrderBy {...orderBy} on:change={onChange} />
  {#if briefcase}
    <div>
      <Briefcase {...briefcase} />
    </div>
  {/if}
</div>
